import { useService, useServiceWpApi } from '../common/useService';
import reactPress from '../reactpress';
import axios from 'axios';
import User from './User';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const WPAPI = require('wpapi');

const useGetCurrentUser = () => {
  return useServiceWpApi((userId: number) => {
    const wp = new WPAPI({ endpoint: reactPress.api.rest_url, nonce: reactPress.api.nonce });
    return wp.users().id(userId);
  });
};

const useGetDecodedUserInfo = () =>
  useService((hash: string) => {
    return axios.post<User>('/my-account-api/user/decode-identity-hash.php', { hash });
  });

const UserService = {
  useGetCurrentUser,
  useGetDecodedUserInfo,
};

export default UserService;
